import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { sectorBySlug } from "../data/sectors";
import { serviceBySlug } from "../data/services";
import { getHead } from "../seo/routes";
import { Seo } from "../components/Seo";
import { PageHero, Prose, CTABand, Breadcrumbs, SectionHead } from "../components/Blocks";
import NotFound from "./NotFound";

export default function SectorPage() {
  const { slug } = useParams();
  const sector = sectorBySlug[slug];
  if (!sector) return <NotFound />;
  const path = `/sectors/${sector.slug}`;
  const head = getHead(path, { sector });
  return (
    <>
      <Seo title={head.title} description={head.description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Sectors", to: "/sectors" }, { label: sector.name }]} />
      <PageHero overline="Industry Sector" title={`${sector.name} Security`} lead={sector.blurb} image={sector.image} />
      <Prose paragraphs={[sector.copy, `Maze Security Solutions delivers ${sector.name.toLowerCase()} security across all 13 Canadian provinces and territories, with guards licensed under each province's regulatory framework, supervised shifts and time-stamped digital reporting on every engagement.`]} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-testid="sector-services">
        <SectionHead overline="Recommended" title={`Security Services for ${sector.name}`} />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl">
          {sector.services.map((slug) => {
            const s = serviceBySlug[slug];
            return (
              <Link key={slug} to={`/services/${slug}`} data-testid={`sector-service-${slug}`} className="group flex items-center justify-between border border-white/10 bg-[#181C28] hover:border-[#FF5500]/50 rounded-sm p-5 transition-all duration-200 hover:-translate-y-0.5">
                <div>
                  <h3 className="font-display text-lg font-bold uppercase tracking-tight text-white group-hover:text-[#FF5500] transition-colors">{s.name}</h3>
                  <p className="mt-1 text-xs text-gray-400">{s.short}</p>
                </div>
                <ArrowRight className="h-4 w-4 text-[#FF5500] shrink-0 ml-3" />
              </Link>
            );
          })}
        </div>
      </section>
      <CTABand title={`Protect Your ${sector.name} Operation`} sub="Speak with dispatch about your sites, hours and risk profile — coverage starts with a walk-through and written post orders." />
    </>
  );
}
